import React, { useEffect, useState } from "react";
import axios from "axios";
import imageCompression from "browser-image-compression";
import { BASE_URL } from "../../Utils/BaseUrl";
import {
  Box,
  Avatar,
  Card,
  CardContent,
  Typography,
  Grid,
  Button,
  LinearProgress,
} from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PostAddIcon from "@mui/icons-material/PostAdd";

const UserProfile = () => {
  const user_id = localStorage.getItem("user_id");

  const [profile, setProfile] = useState({});
  const [followers, setFollowers] = useState(0);
  const [following, setFollowing] = useState(0);
  const [posts, setPosts] = useState(0);

  const [imageFile, setImageFile] = useState(null);
  const [preview, setPreview] = useState("");
  const [uploading, setUploading] = useState(false);

  const fetchProfile = async () => {
    try {
      const res = await axios.post(`${BASE_URL}/profile_data`, { user_id });
      if (res.data[0]) {
        setProfile(res.data[0]);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const fetchCounts = async () => {
    try {
      const fol = await axios.post(`${BASE_URL}/following`, { user_id });
      setFollowing(fol.data[0]?.following || 0);

      const flw = await axios.post(`${BASE_URL}/follower`, { user_id });
      setFollowers(flw.data[0]?.follower || 0);

      const pst = await axios.post(`${BASE_URL}/posts_count`, { user_id });
      setPosts(pst.data[0]?.post || 0);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchProfile();
    fetchCounts();
  }, []);

  const handleImageSelect = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const allowedExtensions = ["png", "jpg", "jpeg"];
    const ext = file.name.split(".").pop().toLowerCase();
    if (!allowedExtensions.includes(ext)) return;

    try {
      const compressedFile = await imageCompression(file, {
        maxSizeMB: 0.3,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      });

      setImageFile(compressedFile);

      const reader = new FileReader();
      reader.readAsDataURL(compressedFile);
      reader.onload = () => setPreview(reader.result);
    } catch (err) {
      console.error(err);
    }
  };

  const handleImageUpload = async () => {
    if (!imageFile) return;

    setUploading(true);

    const formData = new FormData();
    formData.append("image", imageFile);
    formData.append("user_id", user_id);

    try {
      const res = await axios.post(`${BASE_URL}/profile_pic`, formData);

      if (res.data[0]?.profile_image) {
        setProfile((prev) => ({
          ...prev,
          profile_image: res.data[0].profile_image,
        }));

        setPreview("");
        setImageFile(null);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setUploading(false);
    }
  };

  return (
    <Card sx={{ maxWidth: 300, p: 2, borderRadius: 3, boxShadow: 3 }}>
      <Box textAlign="center" sx={{ position: "relative" }}>
        <input
          accept="image/*"
          type="file"
          id="upload-profile"
          style={{ display: "none" }}
          onChange={handleImageSelect}
        />

        <label htmlFor="upload-profile" style={{ cursor: "pointer" }}>
          <Avatar
            src={
              preview ||
              `https://thetalentclub.co.in/upload/profile/${profile.profile_image}`
            }
            sx={{ width: 100, height: 100, mb: 1 }}
          >
            {profile.firstname?.charAt(0)}
          </Avatar>
        </label>

        {imageFile && (
          <Button
            variant="contained"
            size="small"
            sx={{ mt: 1 }}
            onClick={handleImageUpload}
            disabled={uploading}
          >
            {uploading ? "Uploading..." : "Upload"}
          </Button>
        )}

        {uploading && <LinearProgress sx={{ mt: 1 }} />}
      </Box>

      <CardContent sx={{ textAlign: "center" }}>
        <Typography variant="h6" fontWeight={600}>
          {profile.firstname} {profile.lastname}
        </Typography>

        <Typography variant="body2" color="text.secondary">
          {profile.email || "No email"}
        </Typography>

        {/* <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {profile.mobile || "No mobile"}
        </Typography> */}

        <Grid container justifyContent="space-around" sx={{ mt: 2 }}>
          <Grid item textAlign="center">
            <PeopleIcon sx={{ color: "#1976d2" }} />
            <Typography variant="h6">{followers}</Typography>
            <Typography variant="caption">Followers</Typography>
          </Grid>

          <Grid item textAlign="center">
            <PersonAddIcon sx={{ color: "#d32f2f" }} />
            <Typography variant="h6">{following}</Typography>
            <Typography variant="caption">Following</Typography>
          </Grid>

          <Grid item textAlign="center">
            <PostAddIcon sx={{ color: "#388e3c" }} />
            <Typography variant="h6">{posts}</Typography>
            <Typography variant="caption">Posts</Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default UserProfile;